import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=21512248&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=21512248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21512248",
  null
  
)

export default component.exports